module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tag-select', {
    staticClass: "forum-tag-select",
    attrs: {
      "search": _vm.search,
      "canCreate": _vm.canCreate,
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00a4f2c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/tag-select.vue
// module id = 1955
// module chunks = 2